import { AxiosResponse } from "axios";
import { VaMethodology } from "../../../Model/Dto/VerificationAgency/VaMethodology";
import { SearchResult } from "../../../Model/Dto/SearchResult";
import { axiosCoreInstance } from "../../AxiosCoreInterceptor";

import * as ApiUrls from './ApiUrl.VAMethodology';;
export const VAMethodologyService = {
    Search : (input : VaMethodology.VaMethodologySearchRequest) : Promise<AxiosResponse<SearchResult<VaMethodology.VaMethodologySearchResult>>> => 
    axiosCoreInstance.post(ApiUrls.VAMethodologySearch,input),
    MoveVAMethodology : (id : number, moveDirection : string, scorecardElementType : number) : Promise<AxiosResponse<void>> =>
    axiosCoreInstance.post(`${ApiUrls.VAMethodologySortOrder}?id=${id}&move=${moveDirection}&scorecardElementTypes=${scorecardElementType}`),
    Include : (id: number, include: boolean) : Promise<AxiosResponse<void>> =>
    axiosCoreInstance.post(`${ApiUrls.VAMethodologyInclude}?id=${id}&include=${include}`),
    Delete: (id: number) : Promise<AxiosResponse<void>> =>
    axiosCoreInstance.delete(`${ApiUrls.VAMethodologyDelete}?id=${id}`),
    Upsert : (input : VaMethodology.VaMethodologyDataSubmit) : Promise<AxiosResponse<string>> =>
    axiosCoreInstance.post(ApiUrls.VAMethodologyCreate,input),
}